// Topics offered first: the first-run picker, and the short list on the duel
// screen before "Show all topics".
export const STARTER_TOPICS = ['Movies', 'Sports', 'Geography', 'Music', 'Games', 'Food'];
